import { render, staticRenderFns } from "./UserListItem.vue?vue&type=template&id=72f3726f&scoped=true"
import script from "./UserListItem.ts?vue&type=script&lang=ts&external"
export * from "./UserListItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3726f",
  null
  
)

export default component.exports